import { IConfig } from '@makemydeal/dr-activities-common';

export const isDealerUser = (config: IConfig): boolean => config?.userContext?.isDealer || false;
export const isDeskingUser = (config: IConfig): boolean => config?.userContext?.isDesking || false;
export const isShowroomExperience = (config: IConfig): boolean => config?.userContext?.isDealerShowroomExperience || false;
